import { DAY_OF_WEEK } from 'src/features/membershipType/types';

export const bgToEnDays: Record<string, string> = {
    понеделник: DAY_OF_WEEK.MONDAY,
    вторник: DAY_OF_WEEK.TUESDAY,
    сряда: DAY_OF_WEEK.WEDNESDAY,
    четвъртък: DAY_OF_WEEK.THURSDAY,
    петък: DAY_OF_WEEK.FRIDAY,
    събота: DAY_OF_WEEK.SATURDAY,
    неделя: DAY_OF_WEEK.SUNDAY,
};
